import React, {
  Suspense,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import {
  checkGracePeriod,
  getGraceFormattedTime,
  getPreExpiryFormattedTime,
  checkPreExpireDate,
  getUserAccessPayload,
  getGeoCountry,
  checkNewUser,
  //getSubscriptionPlan,
} from 'utils/primeUtil';
import {
  getQueryParams,
  collectEventfireGa4,
  getGa4PageViewSet,
} from 'utils/common';
import { toggleLoginBox } from 'components/Login/redux';
import _get from 'lodash.get';
import {
  // PRC_FOR_SUBSCRIBED,
  TOI_SUBS_PLAN_TRANSLATION_WEB,
  TOI_SUBS_PLAN_TRANSLATION_MWEB,
  IMAGE_URL,
  PRC_FOR_NEVER_REGISTER,
  PRC_FOR_NOT_LOGIN,
} from 'constants/index';
import { loginEventEmitter, logOutEventEmitter } from 'components/Login';
import ErrorBoundary from 'components/ErrorBoundary';
import {
  setupWebViewJavascriptBridge,
  printSignInDeeplink,
  requestUnifiedAppLogin,
  isIOS,
  hasNewTilBridge,
} from 'helpers/frmapp/frmAppLink';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import makeRequest from 'utils/makeRequest';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { handlePlanClick } from 'components/ToiSubscription/utils/payment';
import { connect } from 'react-redux';
import s from './toipNudges.scss';
// import ElementInView from '../ElementInView/ElementInView';
import StoryBlockerV3 from './StoryBlockerV3/StoryBlockerV3';

const HomePageNudge = React.lazy(() => import('./HomePageNudge'));
const StoryBlockerNew = React.lazy(() =>
  import('components_v2/common/ToipNudges/StoryBlockerNew/StoryBlockerNew'),
);
const PrimeRenewStrip = React.lazy(() =>
  import('./PrimeRenewStrip/PrimeRenewStrip'),
);

const HomePageRenewNudge = React.lazy(() =>
  import('components_v2/mobile/HomePageRenewNudge/HomePageRenewNudge'),
);

const ToipNudges = ({
  viewType,
  showToiPlusNudges,
  isToiPlusAllowReadOnly,
  isWapView,
  userData,
  msid,
  title,
  isPrime,
  frmapp,
  isAppView,
  geo,
  storyTitle,
  userPrcData,
  transLoading,
  isUpgrade,
  toggleLoginBoxFn,
  unifiedNodes,
  // showBundleCardMessage,
  shouldShowPopUp,
  blockerPopUp,
  showFreeTrailBlocker,
  closePopUpRef,
}) => {
  const [hasMounted, setHasMounted] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState('LOADING');
  const [nudgeHeight, setNudgeHeight] = useState('');
  const [isGracePeriod, setGracePeriod] = useState(false);
  const [graceDate, setGraceDate] = useState('');
  const [daysRemaining, setDaysRemaining] = useState(false);
  const [ispreExpired, setIsPreExpired] = useState(false);
  const [accessPayload, setaccessPayload] = useState({});
  const isToiPlusAllowReadOnlyRef = useRef(false);
  const [userType, setUserType] = useState(null);
  const [scrollDirection, setScrollDirection] = useState(false);
  const [oldValue, setOldValue] = useState(0);

  const showFreeTrailBlockerRef = useRef(showFreeTrailBlocker);

  const isLoggedIn =
    userData && userData.isLoggedIn ? userData.isLoggedIn : undefined;
  const prcValue = userData && userData.prcValue ? userData.prcValue : 0;

  const inViewGA = pageType => {
    let category = '';
    let action;
    switch (pageType) {
      case 'toiplusprimeshow':
      case 'newtoiplusprimeshow':
        action = 'prime-login_blocker_Radio|View';
        break;
      case 'printHomePage':
        action = 'Printed_blocker_View';
        break;
      case 'printArticleShow':
        action = 'Printed_storyblocker_View';
        break;
      default:
        action = 'prime-login_blocker|View';
    }

    if (isToiPlusAllowReadOnlyRef.current) {
      action = 'blocked_prime-login_blocker|View';
    }

    switch (pageType) {
      case 'toiplushomepage':
        if (isWapView) {
          category = 'WAP-primehome';
        } else {
          category = 'WEB-Prime-Home';
        }
        break;
      case 'toiplusprimeshow':
        category = isWapView ? 'WAP-newprimeshow' : 'WEB-newprimeshow';
        break;
      case 'newtoiplusprimeshow':
        category = isWapView ? 'WAP-newprimeshow' : 'WEB-newprimeshow';
        break;
      case 'printHomePage':
        category = isWapView
          ? 'WAP-Printedlandingpage'
          : 'WEB-Printedlandingpage';
        break;
      case 'printArticleShow':
        category = isWapView ? 'WAP-Printedprimeshow' : 'WEB-Printedprimeshow';
        break;
      default:
        if (isWapView) {
          category = 'WAP-primelist';
        } else {
          category = 'WEB-Prime-HPListing';
        }
    }

    // if (isWapView) {
    //   category = 'WAP-primehome';
    // } else if (isHomePage) {
    //   category = 'WEB-Prime-Home';
    // } else {
    //   category = 'WEB-Prime-HPListing';
    // }
    analyticsWrapper(
      'ga',
      'send',
      'event',
      category,
      action,
      `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
    );
  };

  useEffect(() => {
    if (!isIOS) {
      window.androidObj = function AndroidClass() {};
    }
  }, []);

  useEffect(
    () => {
      setHasMounted(true);
      if (userPrcData) {
        checkGracePeriod(userPrcData).then(res => {
          setGracePeriod(res);
        });
        getGraceFormattedTime(userPrcData).then(res => {
          setGraceDate(res);
        });
        getPreExpiryFormattedTime(userPrcData).then(res => {
          setDaysRemaining(res);
        });
        checkPreExpireDate(userPrcData).then(res => {
          setIsPreExpired(res);
        });
        setaccessPayload(getUserAccessPayload());
      }
    },
    [userPrcData],
  );
  useEffect(
    () => {
      isToiPlusAllowReadOnlyRef.current = isToiPlusAllowReadOnly;
    },
    [isToiPlusAllowReadOnly],
  );

  useEffect(
    () => {
      if (userPrcData) {
        checkNewUser(userPrcData).then(res => {
          setUserType(res);
        });
      }
    },
    [userPrcData],
  );
  useEffect(() => {
    window.addEventListener('scroll', () => {
      // Get the new Value
      const newValue = window.pageYOffset;

      //Subtract the two and conclude
      if (oldValue - newValue > 0 && newValue > 50) {
        setScrollDirection(true);
      } else {
        setScrollDirection(false);
      }
      // Update the old value
      setOldValue(newValue);
    });
  });

  useEffect(
    () => {
      showFreeTrailBlockerRef.current = showFreeTrailBlocker;
    },
    [showFreeTrailBlocker],
  );

  const Loader = () => {
    if (viewType === 'toiplusprimeshow') {
      return (
        <LoaderSpinner
          overwriteWrapper={s.spinnerwrapper}
          overwriteLoader={s.spinner}
        />
      );
    }
    if (
      viewType === 'newtoiplusprimeshow' ||
      viewType === 'printHomePage' ||
      viewType === 'printArticleShow' ||
      viewType === 'toiplusprimeshowV3'
    ) {
      return <img src={`${IMAGE_URL}99553042.cms`} alt="shimmer" />;
    }
    return null;
  };

  const getLoadingStatus = status => {
    setLoadingStatus(status);
  };

  const getNudgeHeight = (height = 0) => {
    setNudgeHeight(height);
  };

  const fireGA = action => {
    const innerCategory = isWapView ? 'wap-newprimeshow' : 'web-newprimeshow';
    if (typeof window !== 'undefined') {
      analyticsWrapper(
        'ga',
        'send',
        'event',
        innerCategory,
        action,
        `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
      );
    }
  };

  const fireGA4 = obj => {
    const gaPageViewObj = getGa4PageViewSet() || {};
    const collatedGadata = {
      ...gaPageViewObj,
      event: obj?.action === 'click' ? 'select_item' : 'view_item_list',
    };
    return collectEventfireGa4(collatedGadata, {
      item_name:
        window.location.href.indexOf('.cms') > -1
          ? document.title
          : window.location.href,
      item_id: msid || '',
      item_brand: 'product_interventions',
      item_category: 'Nudges',
      item_category2: obj?.item_category2 || 'N/A',
      item_category3: obj?.item_category3 ? obj?.item_category3 : 'N/A',
      item_category4: obj?.item_category4 ? obj?.item_category4 : 'N/A',
    });
  };

  const fireInViewGAandCDP = useCallback(() => {
    const showFreeTrail = showFreeTrailBlockerRef.current;
    const grxParams = [
      'subscriptions_blocker',
      {
        client_source: 'cdp',
        event_nature: 'impression',
        event_category: 'subscription',
        cta_text: '',
        paywalling_type: showFreeTrail ? 'free_trial' : '',
      },
    ];
    if (
      typeof window?.grx !== 'undefined' &&
      typeof window?.grx_module?.hitPaywallEventReact === 'function'
    ) {
      window.grx_module.hitPaywallEventReact(
        isUpgrade ? 'upgrade_blocker' : 'subscription_feature',
        grxParams[1],
      );
    } else {
      window.Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
        eventName: !isUpgrade ? 'subscription_feature' : 'upgrade_blocker',
        payload: grxParams[1],
      });
    }
    fireGA4({
      action: 'view',
      item_category2: `${
        window.location.href.indexOf('printarticle') > -1
          ? 'articleshow'
          : 'listing'
      }${showFreeTrail ? '_freeTrial' : ''}`,
    });
  }, []);

  const onPlanClickHandler = async () => {
    fireGA('prime-login_blocker_Radio_CTA');
    const geoCountry = getGeoCountry() || 'IN';
    let url;
    if (isWapView) {
      url = `${TOI_SUBS_PLAN_TRANSLATION_WEB}&cc=${geoCountry}`;
    } else {
      url = `${TOI_SUBS_PLAN_TRANSLATION_MWEB}&cc=${geoCountry}`;
    }

    const translationApiRes = await makeRequest.get(url);
    const { data: translationData = {} } = translationApiRes;
    //const selectedPlan = await getSubscriptionPlan(geoCountry, isWapView);
    handlePlanClick(
      null,
      translationData,
      userData,
      isWapView,
      getGeoCountry(),
      //  selectedPlan,
      {
        // selectedPlan,
        isGracePeriod,
        ispreExpired,
        userType,
        daysRemaining,
        pageType: viewType,
        justPayRedirect: true,
        offer: false,
      },
    );
  };

  const getLoginComponent = () => {
    const intiaiteLogin = e => {
      const showFreeTrail = showFreeTrailBlockerRef.current;
      fireGA4({
        action: 'click',
        item_category4: e.target.innerText || '',
        item_category3: 'paywall_blocker_alreadySubscribed_freeTrial',
        item_category2: `${
          window.location.href.indexOf('printarticle') > -1
            ? 'articleshow'
            : 'listing'
        }${showFreeTrail ? '_freeTrial' : ''}`,
      });
      if (
        typeof window !== 'undefined' &&
        getQueryParams('tophead') === 'epaper'
      ) {
        toggleLoginBoxFn(true);
      } else {
        loginEventEmitter(undefined, {});
      }
      fireGA('prime-login_blocker|LoginCTA');
      if (blockerPopUp && closePopUpRef?.current) {
        closePopUpRef.current(e, false);
      }
      let category;
      if (blockerPopUp) {
        category = 'paywall_bottomsheet_blocker_alreadySubscribed';
      } else if (showFreeTrailBlocker) {
        category = 'paywall_blocker_alreadySubscribed_freeTrial';
      } else {
        category = 'paywall_blocker_alreadySubscribed';
      }
      fireGA4({
        action: 'click',
        item_category4: e.target.innerText || '',
        item_category3: category,
        item_category2: `${
          window.location.href.indexOf('printarticle') > -1
            ? 'articleshow'
            : 'listing'
        }${showFreeTrail ? '_freeTrial' : ''}`,
      });
    };
    const checkintiaiteLogin = e => {
      switch (viewType) {
        case 'printHomePage':
        case 'printArticleShow':
          fireGA('Printed_login');
          break;
        case 'newtoiplusprimeshow':
          fireGA('prime-login_blocker|LoginCTA');
          break;
        default:
      }
      if (isAppView) {
        if (hasNewTilBridge()) {
          requestUnifiedAppLogin();
        } else if (isIOS) {
          setupWebViewJavascriptBridge(bridge => printSignInDeeplink(bridge));
        } else {
          //For communicating between App JS Interface
          try {
            printSignInDeeplink();
          } catch (err) {
            console.log('bridge not generated', err);
          }
        }
      } else if (isLoggedIn) {
        window.showLogoutToastMsg = true;
        logOutEventEmitter();
        setTimeout(() => {
          intiaiteLogin(e);
        }, 1000); //todo: improve this check
      } else {
        intiaiteLogin(e);
      }
    };
    return (
      <div
        className={`${s.login} ${
          !showFreeTrailBlockerRef.current ? s.space : ''
        }`}
      >
        Already a Member?
        <a onClick={e => checkintiaiteLogin(e)} className={s.loginLink}>
          {showFreeTrailBlockerRef.current ? 'Sign in' : 'Login'}
        </a>
      </div>
    );
  };

  const renderUI = () => {
    if (Object.keys(userData).length > 0) {
      switch (viewType) {
        case 'toiplushomepage':
          return (
            <InViewObserver
              className={`${s.nudge_sticky} ${
                userData.prcValue === PRC_FOR_NEVER_REGISTER ||
                userData.prcValue === PRC_FOR_NOT_LOGIN
                  ? s.sticky
                  : ''
              } ${scrollDirection ? s.scrollup : s.scrolldown}`}
              inViewCallback={() => {
                inViewGA(viewType);
              }}
              viewMargin="0px 0px 0px 0px"
            >
              <div
                className={`${s.nudge_wraper} ${
                  loadingStatus === 'DONE' ? s.loaded : ''
                } ${isGracePeriod ? s.graceUser : ''}`}
                style={{
                  height: nudgeHeight,
                  ...(nudgeHeight === 0 ? { margin: 0 } : {}),
                }}
              >
                <HomePageNudge
                  viewType={viewType}
                  isWapView={isWapView}
                  userData={userData}
                  isToiPlusAllowReadOnly={isToiPlusAllowReadOnly}
                  inGracePeriod={isGracePeriod}
                  graceDate={graceDate}
                  daysRemaining={daysRemaining}
                  ispreExpired={ispreExpired}
                  accessPayload={accessPayload}
                  frmapp={frmapp}
                  geo={geo?.currentCountry}
                  getLoadingStatus={getLoadingStatus}
                  getNudgeHeight={getNudgeHeight}
                  userPrcData={userPrcData}
                  unifiedNodes={unifiedNodes}
                />
              </div>
            </InViewObserver>
          );

        case 'toiplusplanpage':
          return null;
        case 'newtoiplusprimeshow':
          return (
            <InViewObserver
              inViewCallback={() => {
                inViewGA(viewType);
                fireInViewGAandCDP();
              }}
              viewMargin="0px 0px 0px 0px"
            >
              <StoryBlockerNew
                loginComponent={getLoginComponent()}
                onPlanClickHandler={onPlanClickHandler}
                isWapView={isWapView}
                userData={userData}
                storyTitle={storyTitle}
                msid={msid}
                isToiPlusAllowReadOnly={isToiPlusAllowReadOnly}
                viewType={viewType}
                isAppView={isAppView}
                isUpgrade={isUpgrade}
                userPrcData={userPrcData}
                frmapp={frmapp}
              />
            </InViewObserver>
          );
        case 'storyRenewStrip':
          return (
            <div
              className={`${s.nudge_wraper} ${
                loadingStatus === 'DONE' ? s.loaded : ''
              } ${isGracePeriod ? s.graceUser : ''}`}
              style={{ height: nudgeHeight }}
            >
              <PrimeRenewStrip
                isWapView={isWapView}
                title={title}
                userData={userData}
                msid={msid}
                accessPayload={accessPayload}
                isPrime={isPrime}
                isAppView={isAppView}
                userPrcData={userPrcData}
                getNudgeHeight={getNudgeHeight}
                inGracePeriod={isGracePeriod}
                graceDate={graceDate}
                daysRemaining={daysRemaining}
                ispreExpired={ispreExpired}
              />
            </div>
          );
        case 'ToiHpRenewNudge':
          return (
            <div
              className={`${s.nudge_wraper} ${
                loadingStatus === 'DONE' ? s.loaded : ''
              } ${isGracePeriod ? s.graceUser : ''}`}
              style={{ height: nudgeHeight, marginBottom: '16px' }}
            >
              <HomePageRenewNudge
                userData={userData}
                isToiPlusAllowReadOnly={isToiPlusAllowReadOnly}
                inGracePeriod={isGracePeriod}
                graceDate={graceDate}
                daysRemaining={daysRemaining}
                ispreExpired={ispreExpired}
                userPrcData={userPrcData}
                getNudgeHeight={getNudgeHeight}
              />
            </div>
          );
        case 'toiplusprimeshowV3':
        case 'printHomePage':
        case 'printArticleShow':
          return (
            <InViewObserver
              inViewCallback={fireInViewGAandCDP}
              viewMargin="0px 0px 0px 0px"
            >
              <StoryBlockerV3
                loginComponent={getLoginComponent()}
                onPlanClickHandler={onPlanClickHandler}
                isWapView={isWapView}
                userData={userData}
                storyTitle={storyTitle}
                msid={msid}
                isToiPlusAllowReadOnly={isToiPlusAllowReadOnly}
                userPrcData={userPrcData}
                getLoadingStatus={getLoadingStatus}
                shouldShowPopUp={shouldShowPopUp}
                blockerPopUp={blockerPopUp}
                isUpgrade={isUpgrade}
                isAppView={isAppView}
                viewType={viewType}
                closePopUpRef={closePopUpRef}
              />
            </InViewObserver>
          );
        default: {
          return (
            <InViewObserver
              className={s.nudge_sticky}
              inViewCallback={() => {
                inViewGA(viewType);
              }}
              viewMargin="0px 0px 0px 0px"
            >
              <div
                className={`${s.nudge_wraper} ${
                  loadingStatus === 'DONE' ? s.loaded : ''
                } ${isGracePeriod ? s.graceUser : ''}`}
                style={{
                  height: nudgeHeight,
                  ...(nudgeHeight === 0 ? { margin: 0 } : {}),
                }}
              >
                <HomePageNudge
                  viewType={viewType}
                  isWapView={isWapView}
                  userData={userData}
                  isToiPlusAllowReadOnly={isToiPlusAllowReadOnly}
                  inGracePeriod={isGracePeriod}
                  graceDate={graceDate}
                  daysRemaining={daysRemaining}
                  ispreExpired={ispreExpired}
                  accessPayload={accessPayload}
                  frmapp={frmapp}
                  geo={geo?.currentCountry}
                  getLoadingStatus={getLoadingStatus}
                  getNudgeHeight={getNudgeHeight}
                  userPrcData={userPrcData}
                  unifiedNodes={unifiedNodes}
                />
              </div>
            </InViewObserver>
          );
        }
      }
    }
    return null;
  };

  if (
    !showToiPlusNudges &&
    viewType !== 'toiplusprimeshow' &&
    viewType !== 'newtoiplusprimeshow' &&
    viewType !== 'printHomePage' &&
    viewType !== 'printArticleShow' &&
    viewType !== 'storyRenewStrip' &&
    viewType !== 'toiplusprimeshowV3'
  ) {
    return null;
  }

  return (
    <ErrorBoundary>
      {(!hasMounted ||
        (loadingStatus === 'LOADING' && transLoading !== 'DONE') ||
        transLoading === 'LOADING') && <Loader />}
      {hasMounted && <Suspense fallback={<div />}>{renderUI()}</Suspense>}
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  transLoading: state.translationConfig.transLoading,
  showToiPlusNudges: state.toiplusconfig?.showToiPlusNudges,
  isToiPlusAllowReadOnly: state.toiplusconfig?.isToiPlusAllowReadOnly,
  userPrcData: state.login.userPrcData,
  unifiedNodes: _get(state, 'translationConfig.nudges.unifiedNodes', {}),
  showFreeTrailBlocker: state.login.showFreeTrailBlocker,
});

const mapDispatchToProps = dispatch => ({
  toggleLoginBoxFn: params => {
    dispatch(toggleLoginBox(params));
  },
});

export default React.memo(
  connect(mapStateToProps, mapDispatchToProps)(ToipNudges),
);

ToipNudges.propTypes = {
  viewType: PropTypes.string,
  isWapView: PropTypes.bool,
  userData: PropTypes.shape({
    prcValue: PropTypes.number,
    isLoggedIn: PropTypes.bool,
  }),
  msid: PropTypes.string,
  isToiPlusAllowReadOnly: PropTypes.bool,
  frmapp: PropTypes.bool,
  isAppView: PropTypes.bool,
  title: PropTypes.string,
  isPrime: PropTypes.bool,
  geo: PropTypes.shape({
    currentCountry: PropTypes.string,
  }),
  storyTitle: PropTypes.string,
  isUpgrade: PropTypes.bool,
  transLoading: PropTypes.string,
  shouldShowPopUp: PropTypes.func,
  blockerPopUp: PropTypes.bool,
  showFreeTrailBlocker: PropTypes.bool,
};

ToipNudges.defaultProps = {
  viewType: '',
  isWapView: false,
  userData: PropTypes.shape({
    prcValue: undefined,
    isLoggedIn: false,
  }),
  msid: '',
  isToiPlusAllowReadOnly: false,
  frmapp: false,
  isAppView: false,
  title: '',
  isPrime: false,
  geo: {},
  storyTitle: '',
  isUpgrade: false,
  transLoading: '',
  blockerPopUp: false,
  shouldShowPopUp: () => {},
  showFreeTrailBlocker: false,
};
